import { animated, useSpring } from "@react-spring/web";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import useBodyScrollLock from "../../../../../../../hooks/useBodyScrollLock";
import useCloseSelector from "../../../../../../../hooks/useCloseSelector";
import { useMediaQuery } from "../../../../../../../hooks/useMediaQuery";
import CloseIcon from "../../../../../../Icons/CloseIcon";
import Modal from "../../../../../../Modal/Modal";
import MainHeaderStore from "../../../../../stores/MainHeaderStore";
import { CartList } from "../CartList/CartList";
import s from "./CartContent.module.scss";

type Props = {
  mainHeaderStore: MainHeaderStore;
};

interface OverlaySpringProps {
  opacity: number;
  pointerEvents: "none" | "all";
}

export const CartContent: React.FC<Props> = observer(({ mainHeaderStore }) => {
  const { ref } = useCloseSelector(() => mainHeaderStore.setCartVisible(false));

  // const cartStore = useUserCartStore();
  // const wallet = useTonWallet();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { lock, unlock } = useBodyScrollLock();

  // Анимация оверлея
  const [overlayStyles, overlayApi] = useSpring<OverlaySpringProps>(() => ({
    from: { opacity: 0, pointerEvents: "none" as const },
  }));

  // Анимация контента корзины
  const [contentStyles, contentApi] = useSpring(() => ({
    from: { opacity: 1, transform: "translateX(420px)" },
  }));

  const toggleCart = () => {
    mainHeaderStore.setCartVisible(!mainHeaderStore.isCartVisible);
  };

  useEffect(() => {
    if (mainHeaderStore.isCartVisible) {
      // Запускаем анимации одновременно
      overlayApi.start({
        opacity: 1,
        pointerEvents: "all",
        config: { tension: 200, friction: 40 },
      });

      contentApi.start({
        opacity: 1,
        transform: "translateX(-10px)",
        config: { tension: 400, friction: 40 },
      });
    } else {
      // Последовательное скрытие: сначала контент, потом оверлей
      contentApi.start({
        opacity: 1,
        transform: "translateX(420px)",
        config: { tension: 400, friction: 40 },
      });

      overlayApi.start({
        opacity: 0,
        delay: 200, // Ждем завершения анимации контента
        pointerEvents: "none",
        config: { tension: 200, friction: 40 },
      });
    }
  }, [mainHeaderStore.isCartVisible]);

  useEffect(() => {
    if (mainHeaderStore.isCartVisible) {
      lock();
    } else {
      unlock();
    }
  }, [mainHeaderStore.isCartVisible]);

  return isMobile ? (
    <Modal
      title="Your cart"
      isOpened={mainHeaderStore.isCartVisible}
      onClose={toggleCart}
    >
      <CartList headerStore={mainHeaderStore} />
    </Modal>
  ) : (
    <div ref={ref}>
      <animated.div
        className={s.overlay}
        style={overlayStyles}
        onClick={() => {
          mainHeaderStore.setCartVisible(false);
        }}
      />

      <animated.div className={clsx(s.wrapper)} style={contentStyles}>
        {
          <div className={s.cart_content_wrapper}>
            <div className={s.cart_content_header}>
              <span>Your Cart</span>
              <div
                onClick={() => {
                  mainHeaderStore.setCartVisible(false);
                }}
              >
                <CloseIcon />
              </div>
            </div>
            <CartList headerStore={mainHeaderStore} />
          </div>
        }
      </animated.div>
    </div>
  );
});
